<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="menu-bar-card gradient-border-primary ">
    <a class="menu-item" *ngFor="let item of menuItems" [routerLink]="item.routeUrl" routerLinkActive="active"
        #rla="routerLinkActive" [routerLinkActiveOptions]="{ exact: true }">
        <i class="menu-icon" [class]="item.icon" [class.active-icon]="rla.isActive"></i>
        <p class="menu-label text-wrap">{{ item.label }}</p>
    </a>
</div>